// // ============================================================
// // src/components/Testimonials.js
// // ============================================================
// import React from "react";
// import { useHospital } from "../context/HospitalContext";

// const AVATAR_COLORS = ["a", "b", "c", "d", "e", "f"];

// const DEFAULT_TESTIMONIALS = [
//   {
//     init: "A",
//     name: "Aisha Mehta",
//     role: "Software Engineer, Pune",
//     stars: "★★★★★",
//     quote:
//       "Dr. Sharma's implant work is absolutely outstanding. I can't believe how natural my new tooth feels — zero pain and completed in just two visits.",
//   },
//   {
//     init: "R",
//     name: "Raj Patel",
//     role: "Business Owner, Mumbai",
//     stars: "★★★★★",
//     quote:
//       "The smile makeover transformed my confidence completely. Dr. Priya's artistry with veneers is incredible — every detail is perfect.",
//   },
//   {
//     init: "S",
//     name: "Sunita Krishnan",
//     role: "School Teacher, Pune",
//     stars: "★★★★★",
//     quote:
//       "Took my 5-year-old to the kids' suite and she actually enjoyed her first dental visit! The team was incredibly patient and gentle.",
//   },
//   {
//     init: "M",
//     name: "Mohammed Qureshi",
//     role: "CA, Pune",
//     stars: "★★★★★",
//     quote:
//       "Invisalign results exceeded my expectations. Dr. Rahul monitored every step. My teeth are perfectly aligned in under 14 months!",
//   },
//   {
//     init: "P",
//     name: "Preeti Sharma",
//     role: "Homemaker, Nashik",
//     stars: "★★★★★",
//     quote:
//       "Root canal with zero pain? I didn't believe it until it happened. The anesthesia was so effective I barely felt anything. Highly recommend!",
//   },
//   {
//     init: "V",
//     name: "Vikram Iyer",
//     role: "Marketing Manager, Pune",
//     stars: "★★★★★",
//     quote:
//       "Premium experience from start to finish. Clean, modern, professional. The digital X-rays and 3D scans gave me full confidence in the diagnosis.",
//   },
// ];

// export default function Testimonials() {
//   const { hospital } = useHospital();

//   // ✅ Dynamic testimonials from hospital config
//   const testimonials =
//     hospital.testimonials && hospital.testimonials.length > 0
//       ? hospital.testimonials
//       : DEFAULT_TESTIMONIALS;

//   // ✅ Dynamic patient count from stats
//   const patientCount = hospital.statPatients || "18,000+";

//   return (
//     <section className="testimonials" id="testimonials">
//       <div className="testimonials-header">
//         <div className="section-tag">Patient Stories</div>
//         <h2 className="section-title">
//           What Our Patients <em>Say</em>
//         </h2>
//         {/* ✅ Dynamic patient count */}
//         <p className="section-desc" style={{ margin: "0 auto" }}>
//           Real stories from real patients. Over {patientCount} smiles
//           transformed and counting.
//         </p>
//       </div>
//       <div className="testimonials-grid">
//         {testimonials.map((t, i) => (
//           <div className="t-card" key={i}>
//             <div className="t-stars">{t.stars || "★★★★★"}</div>
//             <div className="t-quote">"{t.quote}"</div>
//             <div className="t-author">
//               {/* ✅ Avatar color cycles through classes */}
//               <div
//                 className={`t-avatar ${AVATAR_COLORS[i % AVATAR_COLORS.length]}`}
//               >
//                 {(t.init || t.name?.charAt(0) || "?").toUpperCase()}
//               </div>
//               <div>
//                 <div className="t-name">{t.name}</div>
//                 <div className="t-role">{t.role}</div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }
// ============================================================
// src/components/Testimonials.js
// ✅ Specialty-aware default testimonials + dynamic copy
// ✅ Detects dental defaults and overrides for non-dental hospitals
// ============================================================
import React from "react";
import { useHospital } from "../context/HospitalContext";
import { getSpecialtyText } from "../utils/specialtyText";

const AVATAR_COLORS = ["a", "b", "c", "d", "e", "f"];

const SPECIALTY_TESTIMONIALS = {
  dental: [
    {
      init: "A",
      name: "Aisha Mehta",
      role: "Software Engineer, Pune",
      stars: "★★★★★",
      quote:
        "Dr. Sharma's implant work is absolutely outstanding. I can't believe how natural my new tooth feels — zero pain and completed in just two visits.",
    },
    {
      init: "R",
      name: "Raj Patel",
      role: "Business Owner, Mumbai",
      stars: "★★★★★",
      quote:
        "The smile makeover transformed my confidence completely. Dr. Priya's artistry with veneers is incredible — every detail is perfect.",
    },
    {
      init: "S",
      name: "Sunita Krishnan",
      role: "School Teacher, Pune",
      stars: "★★★★★",
      quote:
        "Took my 5-year-old to the kids' suite and she actually enjoyed her first dental visit! The team was incredibly patient and gentle.",
    },
    {
      init: "M",
      name: "Mohammed Qureshi",
      role: "CA, Pune",
      stars: "★★★★★",
      quote:
        "Invisalign results exceeded my expectations. Dr. Rahul monitored every step. My teeth are perfectly aligned in under 14 months!",
    },
    {
      init: "P",
      name: "Preeti Sharma",
      role: "Homemaker, Nashik",
      stars: "★★★★★",
      quote:
        "Root canal with zero pain? I didn't believe it until it happened. The anaesthesia was so effective I barely felt anything. Highly recommend!",
    },
    {
      init: "V",
      name: "Vikram Iyer",
      role: "Marketing Manager, Pune",
      stars: "★★★★★",
      quote:
        "Premium experience from start to finish. Clean, modern, professional. The digital X-rays and 3D scans gave me full confidence in the diagnosis.",
    },
  ],
  ayurved: [
    {
      init: "A",
      name: "Ananya Joshi",
      role: "Yoga Instructor, Pune",
      stars: "★★★★★",
      quote:
        "After years of chronic back pain, 14 days of Panchakarma gave me more relief than anything else I'd tried. My energy levels have completely transformed.",
    },
    {
      init: "R",
      name: "Ramesh Kulkarni",
      role: "Retired Professor, Pune",
      stars: "★★★★★",
      quote:
        "The Vaidya took an hour for my first consultation — understanding my constitution deeply before prescribing anything. That level of care is rare today.",
    },
    {
      init: "S",
      name: "Sneha Deshmukh",
      role: "Homemaker, Nashik",
      stars: "★★★★★",
      quote:
        "My digestion issues of 8 years were resolved in 3 weeks with a customised diet and herbal medicines. I wish I'd come here sooner.",
    },
    {
      init: "M",
      name: "Mihir Shah",
      role: "IT Professional, Pune",
      stars: "★★★★★",
      quote:
        "The Shirodhara session was the most deeply relaxing experience of my life. I sleep better than I have in a decade.",
    },
    {
      init: "P",
      name: "Padma Iyer",
      role: "School Principal, Mumbai",
      stars: "★★★★★",
      quote:
        "Classical authentic Ayurveda — not the spa version. The therapists are well-trained and genuinely knowledgeable. Results speak for themselves.",
    },
    {
      init: "V",
      name: "Vaishali Patil",
      role: "Entrepreneur, Pune",
      stars: "★★★★★",
      quote:
        "Came for stress and anxiety management. The combination of Abhyanga, Pranayama guidance, and herbal medicines has genuinely changed my quality of life.",
    },
  ],
  ortho: [
    {
      init: "A",
      name: "Arun Khanna",
      role: "Retired Army Officer, Pune",
      stars: "★★★★★",
      quote:
        "After my knee replacement I was walking in the corridor the very next morning. Dr. Singh's surgical precision and the physio team's support made recovery seamless.",
    },
    {
      init: "R",
      name: "Rekha Mehta",
      role: "Teacher, Mumbai",
      stars: "★★★★★",
      quote:
        "I was told elsewhere I needed open surgery for my shoulder. Here, the arthroscopic procedure had me back to teaching in 3 weeks. Life-changing.",
    },
    {
      init: "S",
      name: "Saurabh Desai",
      role: "Cricketer, Nashik",
      stars: "★★★★★",
      quote:
        "ACL reconstruction done with minimal scarring. I was back on the cricket field in 6 months — ahead of schedule. Outstanding sports injury expertise.",
    },
    {
      init: "M",
      name: "Meenakshi Pillai",
      role: "Homemaker, Pune",
      stars: "★★★★★",
      quote:
        "15 years of hip pain — gone after surgery. The pain management team ensured I was comfortable throughout. I can now take evening walks again.",
    },
    {
      init: "P",
      name: "Prashant Sawant",
      role: "Construction Engineer, Pune",
      stars: "★★★★★",
      quote:
        "Fractured both wrists in a site accident. The surgical team worked overnight to ensure my hands functioned perfectly. Incredible dedication.",
    },
    {
      init: "V",
      name: "Varsha Kulkarni",
      role: "Software Manager, Pune",
      stars: "★★★★★",
      quote:
        "Spine surgery was something I feared for years. The team's calm explanation, pre-op preparation, and post-op rehab made the entire journey manageable.",
    },
  ],
  eye: [
    {
      init: "A",
      name: "Aarav Gupta",
      role: "Software Developer, Pune",
      stars: "★★★★★",
      quote:
        "LASIK done in under 10 minutes. Next morning I woke up with 6/6 vision for the first time in 15 years. I literally cried. Thank you!",
    },
    {
      init: "R",
      name: "Radha Krishnan",
      role: "Homemaker, Chennai",
      stars: "★★★★★",
      quote:
        "My mother's cataract surgery was completed in 15 minutes and she was home by afternoon. The very next morning she could read the newspaper unaided.",
    },
    {
      init: "S",
      name: "Shweta Patil",
      role: "School Teacher, Pune",
      stars: "★★★★★",
      quote:
        "Detected my child's squint early thanks to a school camp recommendation. The vision therapy has corrected it completely. Early detection is everything.",
    },
    {
      init: "M",
      name: "Manish Tiwari",
      role: "Banker, Mumbai",
      stars: "★★★★★",
      quote:
        "The pre-LASIK evaluation was thorough and honest — they told me exactly what to expect. The procedure itself was painless and results are perfect.",
    },
    {
      init: "P",
      name: "Priya Nair",
      role: "Architect, Pune",
      stars: "★★★★★",
      quote:
        "Diabetic retinopathy management has been excellent. Regular monitoring, laser treatment done with precision. My vision has been preserved for 3 years now.",
    },
    {
      init: "V",
      name: "Vijay Anand",
      role: "Retired IAS Officer, Pune",
      stars: "★★★★★",
      quote:
        "At 72, I was nervous about cataract surgery. The doctor's patience in explaining everything, and the zero-stitch procedure, made it a very positive experience.",
    },
  ],
  cardiology: [
    {
      init: "A",
      name: "Ajay Verma",
      role: "Businessman, Pune",
      stars: "★★★★★",
      quote:
        "Came in with severe chest pain at 2 AM. Within 90 minutes I was in the cath lab and the blockage was cleared. The team literally saved my life that night.",
    },
    {
      init: "R",
      name: "Ranjana Bhosale",
      role: "Homemaker, Nashik",
      stars: "★★★★★",
      quote:
        "My husband's triple bypass was performed flawlessly. He was walking in the ICU corridor on day 2. The cardiac rehab team's follow-up has been outstanding.",
    },
    {
      init: "S",
      name: "Suresh Gokhale",
      role: "Retired Teacher, Pune",
      stars: "★★★★★",
      quote:
        "Pacemaker implantation done under local anaesthesia. I was discharged the next day and back to my morning walks within a week. Incredible modern medicine.",
    },
    {
      init: "M",
      name: "Madhuri Joshi",
      role: "IT Manager, Pune",
      stars: "★★★★★",
      quote:
        "My preventive cardiac check-up detected a significant blockage that was completely asymptomatic. Angioplasty done immediately — I feel I've been given a second life.",
    },
    {
      init: "P",
      name: "Prakash Shetty",
      role: "Hotelier, Goa",
      stars: "★★★★★",
      quote:
        "Flew from Goa for the valve replacement procedure. Worth every kilometer. The cardiac surgery team's expertise and the post-op ICU care were world-class.",
    },
    {
      init: "V",
      name: "Vandana Iyer",
      role: "Gynaecologist, Pune",
      stars: "★★★★★",
      quote:
        "As a doctor myself, I am extremely particular. This team's protocols, hygiene standards, and patient communication are the best I have encountered anywhere.",
    },
  ],
  pediatric: [
    {
      init: "A",
      name: "Anjali Mehra",
      role: "Mother of 2, Pune",
      stars: "★★★★★",
      quote:
        "My toddler was terrified of hospitals. The paediatric team spent 10 minutes just playing with him before the examination. He left asking to come back!",
    },
    {
      init: "R",
      name: "Rohit Sharma",
      role: "Father, Mumbai",
      stars: "★★★★★",
      quote:
        "Our premature baby (28 weeks) spent 6 weeks in the NICU here. The neonatology team's round-the-clock care and updates to us were exceptional. He's thriving now.",
    },
    {
      init: "S",
      name: "Sunita Rao",
      role: "Mother, Hyderabad",
      stars: "★★★★★",
      quote:
        "Travelled from Hyderabad for my daughter's complex cardiac surgery. The paediatric cardiac team's expertise gave us our daughter back. Forever grateful.",
    },
    {
      init: "M",
      name: "Meera Pillai",
      role: "Software Engineer & Mom, Pune",
      stars: "★★★★★",
      quote:
        "Our son has been seen here from age 3 months to now age 7. The continuity of care, the vaccination tracking, the milestone monitoring — everything is seamless.",
    },
    {
      init: "P",
      name: "Parag Kulkarni",
      role: "Father, Nashik",
      stars: "★★★★★",
      quote:
        "My son's asthma has been so well managed that he hasn't had a single hospital admission in 2 years. The action plan and education the doctor gave us transformed our lives.",
    },
    {
      init: "V",
      name: "Vrinda Goyal",
      role: "Mother of Twins, Pune",
      stars: "★★★★★",
      quote:
        "Managing twin toddlers through their vaccination schedule was made easy with appointment reminders, the child-friendly waiting room, and a genuinely patient team.",
    },
  ],
  general: [
    {
      init: "A",
      name: "Aditya Mehta",
      role: "IT Professional, Pune",
      stars: "★★★★★",
      quote:
        "Had my full health check-up done here. Results were explained in detail, not just handed over. The doctor spent time discussing lifestyle changes. Truly comprehensive care.",
    },
    {
      init: "R",
      name: "Rekha Patil",
      role: "Homemaker, Nashik",
      stars: "★★★★★",
      quote:
        "Emergency appendix surgery at midnight — the team was ready and calm. Discharged in 2 days with complete instructions and a follow-up call. Outstanding service.",
    },
    {
      init: "S",
      name: "Suhas Joshi",
      role: "Retired Engineer, Pune",
      stars: "★★★★★",
      quote:
        "Needed to see three specialists in one visit — General Physician, Cardiologist, and Neurologist. One hospital, one afternoon, complete coordination. Very impressive.",
    },
    {
      init: "M",
      name: "Manasi Deshpande",
      role: "Advocate, Pune",
      stars: "★★★★★",
      quote:
        "The reports portal is excellent — all my records in one place, accessible on my phone. More importantly, the doctors actually read the history before the consultation.",
    },
    {
      init: "P",
      name: "Pradeep Kumar",
      role: "Farmer, Satara",
      stars: "★★★★★",
      quote:
        "The Marathi-speaking staff helped bridge the language gap completely. Affordable, dignified, and truly patient-first care. Highly recommended.",
    },
    {
      init: "V",
      name: "Varsha Singh",
      role: "Pharmacist, Pune",
      stars: "★★★★★",
      quote:
        "As a healthcare professional I have high standards. The infection control, drug reconciliation, and discharge counselling here match international benchmarks.",
    },
  ],
};

// ✅ Dental default names — used to detect stale dental data in non-dental hospitals
const DENTAL_DEFAULT_NAMES = [
  "Aisha Mehta",
  "Raj Patel",
  "Sunita Krishnan",
  "Mohammed Qureshi",
  "Preeti Sharma",
  "Vikram Iyer",
];

const SPECIALTY_PATIENT_NOUN = {
  dental: "smiles",
  ayurved: "patients",
  ortho: "patients",
  eye: "patients",
  cardiology: "hearts",
  pediatric: "children",
  general: "patients",
};

export default function Testimonials() {
  const { hospital } = useHospital();
  const type = (hospital?.type || "dental").toLowerCase();
  const t = getSpecialtyText(type);

  const saved = hospital?.testimonials || [];

  // ✅ Detect if non-dental hospital still has dental testimonials saved in DB
  const savedIsDentalDefault =
    saved.length > 0 &&
    DENTAL_DEFAULT_NAMES.every((n) => saved.some((t) => t.name === n));

  // Use type-specific defaults if: empty OR non-dental with dental data
  const testimonials =
    saved.length === 0 || (type !== "dental" && savedIsDentalDefault)
      ? SPECIALTY_TESTIMONIALS[type] || SPECIALTY_TESTIMONIALS.dental
      : saved;

  const patientCount = hospital?.statPatients || "18,000+";
  const noun = SPECIALTY_PATIENT_NOUN[type] || "patients";

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-header">
        <div className="section-tag">Patient Stories</div>
        <h2 className="section-title">
          What Our Patients <em>Say</em>
        </h2>
        <p className="section-desc" style={{ margin: "0 auto" }}>
          Real stories from real patients. Over {patientCount} {noun} helped and
          counting.
        </p>
      </div>
      <div className="testimonials-grid">
        {testimonials.map((t, i) => (
          <div className="t-card" key={i}>
            <div className="t-stars">{t.stars || "★★★★★"}</div>
            <div className="t-quote">"{t.quote}"</div>
            <div className="t-author">
              <div
                className={`t-avatar ${AVATAR_COLORS[i % AVATAR_COLORS.length]}`}
              >
                {(t.init || t.name?.charAt(0) || "?").toUpperCase()}
              </div>
              <div>
                <div className="t-name">{t.name}</div>
                <div className="t-role">{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
